export const trimTooManySpaces = (value: string) => {
  if (value) {
    return value.replace(/\s{2,}/g, ' ');
  } else {
    return value;
  }
};

export const isValidEmail = (email: string) => /\S+@\S+\.\S+/.test(email);
